import { render } from "./ProjectUpdatesNavButtons.vue?vue&type=template&id=5098cba5"
import script from "./ProjectUpdatesNavButtons.vue?vue&type=script&lang=js"
export * from "./ProjectUpdatesNavButtons.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__